import { default as indexxT0G0DqbGQMeta } from "/vercel/path0/pages/alltour/index.vue?macro=true";
import { default as _91id_93qSuc6l4OZKMeta } from "/vercel/path0/pages/booking/received/[id].vue?macro=true";
import { default as indextHkCpcsk7qMeta } from "/vercel/path0/pages/cart/index.vue?macro=true";
import { default as paymentfPH9kZoZZxMeta } from "/vercel/path0/pages/cart/payment.vue?macro=true";
import { default as about_45usxQmj68oTY6Meta } from "/vercel/path0/pages/content/about-us.vue?macro=true";
import { default as contact_45us8xkABKyQ7QMeta } from "/vercel/path0/pages/content/contact-us.vue?macro=true";
import { default as term_45and_45conditionYZPFRR61JsMeta } from "/vercel/path0/pages/content/term-and-condition.vue?macro=true";
import { default as _91DestinationSlug_93GoJXveXyrPMeta } from "/vercel/path0/pages/destination/[DestinationSlug].vue?macro=true";
import { default as _91tourTypeSlug_939cD8D62Z3RMeta } from "/vercel/path0/pages/index/[tourTypeSlug].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as index8pUBN18LvPMeta } from "/vercel/path0/pages/my-bookings/index.vue?macro=true";
import { default as _91PageSlug_93piJGBkijkeMeta } from "/vercel/path0/pages/page/[PageSlug].vue?macro=true";
import { default as registerIikvtlfpbHMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as testpageDf7R1ukzBSMeta } from "/vercel/path0/pages/testpage.vue?macro=true";
import { default as _91tourSlug_93bL6E6bsVOyMeta } from "/vercel/path0/pages/tour/[tourSlug].vue?macro=true";
export default [
  {
    name: "alltour",
    path: "/alltour",
    component: () => import("/vercel/path0/pages/alltour/index.vue")
  },
  {
    name: "booking-received-id",
    path: "/booking/received/:id()",
    component: () => import("/vercel/path0/pages/booking/received/[id].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/vercel/path0/pages/cart/index.vue")
  },
  {
    name: "cart-payment",
    path: "/cart/payment",
    component: () => import("/vercel/path0/pages/cart/payment.vue")
  },
  {
    name: "content-about-us",
    path: "/content/about-us",
    meta: about_45usxQmj68oTY6Meta || {},
    component: () => import("/vercel/path0/pages/content/about-us.vue")
  },
  {
    name: "content-contact-us",
    path: "/content/contact-us",
    meta: contact_45us8xkABKyQ7QMeta || {},
    component: () => import("/vercel/path0/pages/content/contact-us.vue")
  },
  {
    name: "content-term-and-condition",
    path: "/content/term-and-condition",
    meta: term_45and_45conditionYZPFRR61JsMeta || {},
    component: () => import("/vercel/path0/pages/content/term-and-condition.vue")
  },
  {
    name: "destination-DestinationSlug",
    path: "/destination/:DestinationSlug()",
    component: () => import("/vercel/path0/pages/destination/[DestinationSlug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue"),
    children: [
  {
    name: "index-tourTypeSlug",
    path: ":tourTypeSlug()",
    component: () => import("/vercel/path0/pages/index/[tourTypeSlug].vue")
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "my-bookings",
    path: "/my-bookings",
    component: () => import("/vercel/path0/pages/my-bookings/index.vue")
  },
  {
    name: "page-PageSlug",
    path: "/page/:PageSlug()",
    component: () => import("/vercel/path0/pages/page/[PageSlug].vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerIikvtlfpbHMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "testpage",
    path: "/testpage",
    component: () => import("/vercel/path0/pages/testpage.vue")
  },
  {
    name: "tour-tourSlug",
    path: "/tour/:tourSlug()",
    component: () => import("/vercel/path0/pages/tour/[tourSlug].vue")
  }
]